<div class="modal-wrapper">

  <div class="modal-outer-header">
    <h1 class="modal-title">{{ 'booking.title' | translate }}</h1>
    <p class="modal-subtitle">{{ 'booking.subtitle' | translate }}</p>
  </div>

  <!-- ── Step 1: Date & Time ───────────────────────────────────────────── -->
  <ng-container *ngIf="step === 1">
    <div class="modal-card">
      <div class="card-header">{{ 'booking.cardHeader' | translate }}</div>

      <div class="card-body">

        <!-- Left: Calendar -->
        <div class="calendar-panel">
          <h3 class="panel-title">{{ 'booking.selectDateTime' | translate }}</h3>

          <div class="calendar">
            <div class="cal-nav">
              <button class="nav-btn" (click)="prevMonth()" [class.hidden]="!canGoBack">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span class="month-label">{{ monthLabel }}</span>
              <button class="nav-btn" (click)="nextMonth()">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>

            <div class="cal-grid">
              <div class="cal-weekday" *ngFor="let d of weekDays">{{ d }}</div>
              <div
                *ngFor="let day of calendarDays; trackBy: trackByDay"
                class="cal-day"
                [class.other-month]="!day.inMonth"
                [class.past]="day.isPast"
                [class.no-slots]="day.inMonth && !day.isPast && !hasSlots(day)"
                [class.selected]="isSelected(day)"
                [class.has-slots]="day.inMonth && !day.isPast && hasSlots(day)"
                [class.clickable]="day.inMonth && !day.isPast"
                (click)="selectDate(day)">
                {{ day.inMonth ? day.date.getDate() : '' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Right: Time slots -->
        <div class="time-panel">
          <h3 class="panel-title">{{ 'booking.selectTime' | translate }}</h3>
          <p class="timezone-label">{{ 'booking.timezone' | translate }} ({{ timezone }})</p>

          <div class="time-section" *ngIf="morningSlots.length > 0">
            <div class="time-divider">
              <span class="divider-line"></span>
              <span class="divider-label">{{ 'booking.morning' | translate }}</span>
              <span class="divider-line"></span>
            </div>
            <div class="time-grid">
              <button
                *ngFor="let slot of morningSlots; trackBy: trackBySlot"
                class="time-btn"
                [class.selected]="isSlotSelected(slot)"
                (click)="selectSlot(slot)">
                {{ formatSlotTime(slot) }}
              </button>
            </div>
          </div>

          <div class="time-section" *ngIf="afternoonSlots.length > 0">
            <div class="time-divider">
              <span class="divider-line"></span>
              <span class="divider-label">{{ 'booking.afternoon' | translate }}</span>
              <span class="divider-line"></span>
            </div>
            <div class="time-grid">
              <button
                *ngFor="let slot of afternoonSlots; trackBy: trackBySlot"
                class="time-btn"
                [class.selected]="isSlotSelected(slot)"
                (click)="selectSlot(slot)">
                {{ formatSlotTime(slot) }}
              </button>
            </div>
          </div>

          <p class="no-slots-msg" *ngIf="selectedDate && morningSlots.length === 0 && afternoonSlots.length === 0">
            {{ 'booking.noSlots' | translate }}
          </p>
        </div>

      </div><!-- /card-body -->

      <div class="payment-method-picker">
        <p class="picker-label">{{ 'booking.payment.selectMethod' | translate }}</p>
        <div class="picker-options">
          <button
            class="picker-option"
            [class.selected]="paymentMethod === 'CARD'"
            (click)="paymentMethod = 'CARD'">
            <mat-icon>credit_card</mat-icon>
            <span class="option-name">{{ 'booking.payment.card' | translate }}</span>
            <span class="option-desc">{{ 'booking.payment.cardDesc' | translate }}</span>
          </button>
          <button
            class="picker-option"
            [class.selected]="paymentMethod === 'BANK_TRANSFER'"
            (click)="paymentMethod = 'BANK_TRANSFER'">
            <mat-icon>account_balance</mat-icon>
            <span class="option-name">{{ 'booking.payment.bankTransfer' | translate }}</span>
            <span class="option-desc">{{ 'booking.payment.bankTransferDesc' | translate }}</span>
          </button>
        </div>
      </div>

      <div class="card-footer">
        <button class="cancel-btn" (click)="cancel()">{{ 'booking.cancel' | translate }}</button>
        <button class="continue-btn" [disabled]="!canContinue" (click)="goToPayment()">
          {{ paymentLoading ? ('booking.loading' | translate) : ('booking.continue' | translate) }}
          <mat-icon *ngIf="!paymentLoading">arrow_forward</mat-icon>
        </button>
      </div>
      <p *ngIf="paymentError && step === 1" class="payment-error">{{ paymentError }}</p>
    </div>
  </ng-container>

  <!-- ── Step 2: Summary + Payment ────────────────────────────────────── -->
  <ng-container *ngIf="step === 2">
    <div class="step2-body">

      <!-- Left: Summary -->
      <div class="summary-card">
        <h3 class="summary-title">{{ 'booking.summary.title' | translate }}</h3>

        <div class="summary-body">
          <div class="summary-row main-row">
            <span class="summary-service">{{ 'booking.cardHeader' | translate }}</span>
            <span class="summary-price">
  {{ formattedConsultationPrice }}
</span>

          </div>
          <p class="summary-duration">{{ 'booking.summary.duration' | translate }}</p>

          <div class="summary-datetime">
            <span class="datetime-chip">
              <mat-icon class="chip-icon">calendar_today</mat-icon>
              {{ formattedDate }}
            </span>
            <span class="datetime-chip">
              <mat-icon class="chip-icon">schedule</mat-icon>
              {{ formattedTime }}
            </span>
          </div>
        </div>

        <div class="summary-footer">
          <span class="total-label">{{ 'booking.summary.totalDue' | translate }}</span>
          <span class="total-price">
  {{ formattedConsultationPrice }}
</span>
        </div>
      </div>

      <!-- Right: Card payment (Stripe) -->
      <div class="payment-card" *ngIf="paymentMethod === 'CARD'">
        <h3 class="payment-title">{{ 'booking.payment.title' | translate }}</h3>

        <div id="payment-element" class="stripe-element"></div>

        <p *ngIf="paymentError" class="payment-error">{{ paymentError }}</p>

        <div class="payment-actions">
          <button class="cancel-btn" (click)="goBack()" [disabled]="submitting">
            {{ 'booking.back' | translate }}
          </button>
          <button class="book-now-btn" [disabled]="submitting" (click)="bookNow()">
            {{ submitting ? ('booking.processing' | translate) : ('booking.payment.bookNow' | translate) }}
          </button>
        </div>
      </div>

      <!-- Right: Bank Transfer details -->
      <div class="payment-card" *ngIf="paymentMethod === 'BANK_TRANSFER'">
        <h3 class="payment-title">{{ 'booking.payment.bankDetails.title' | translate }}</h3>

        <p class="bank-instruction">{{ 'booking.payment.bankDetails.instruction' | translate }}</p>

        <div class="bank-details">
          <div class="bank-row">
            <span class="bank-label">{{ 'booking.payment.bankDetails.holder' | translate }}</span>
            <span class="bank-value">{{ 'booking.payment.bankDetails.holderValue' | translate }}</span>
          </div>
          <div class="bank-row">
            <span class="bank-label">{{ 'booking.payment.bankDetails.iban' | translate }}</span>
            <span class="bank-value bank-mono">{{ 'booking.payment.bankDetails.ibanValue' | translate }}</span>
          </div>
          <div class="bank-row">
            <span class="bank-label">{{ 'booking.payment.bankDetails.bic' | translate }}</span>
            <span class="bank-value bank-mono">{{ 'booking.payment.bankDetails.bicValue' | translate }}</span>
          </div>
          <div class="bank-row">
            <span class="bank-label">{{ 'booking.payment.bankDetails.bank' | translate }}</span>
            <span class="bank-value">{{ 'booking.payment.bankDetails.bankValue' | translate }}</span>
          </div>
          <div class="bank-row bank-row--reference">
            <span class="bank-label">{{ 'booking.payment.bankDetails.reference' | translate }}</span>
            <span class="bank-value">{{ 'booking.payment.bankDetails.referenceValue' | translate }}</span>
          </div>
        </div>

        <p *ngIf="paymentError" class="payment-error">{{ paymentError }}</p>

        <div class="payment-actions">
          <button class="cancel-btn" (click)="goBack()">
            {{ 'booking.back' | translate }}
          </button>
          <button class="book-now-btn" [disabled]="submitting" (click)="confirmBankTransfer()">
            {{ submitting ? ('booking.processing' | translate) : ('booking.payment.bankDetails.confirmBooking' | translate) }}
          </button>
        </div>
      </div>

    </div>
  </ng-container>

</div>